import { render, staticRenderFns } from "./chargeWeight.vue?vue&type=template&id=1aa33128&scoped=true&"
import script from "./chargeWeight.vue?vue&type=script&lang=js&"
export * from "./chargeWeight.vue?vue&type=script&lang=js&"
import style0 from "./chargeWeight.vue?vue&type=style&index=0&id=1aa33128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa33128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aa33128')) {
      api.createRecord('1aa33128', component.options)
    } else {
      api.reload('1aa33128', component.options)
    }
    module.hot.accept("./chargeWeight.vue?vue&type=template&id=1aa33128&scoped=true&", function () {
      api.rerender('1aa33128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/chargeWeight.vue"
export default component.exports